import { Component, OnInit, Input } from '@angular/core';
import { Chart, TooltipItem } from 'chart.js';
import { MillionPipe } from '../../pipes/million.pipe';
import { currencyMilionPipe } from '../../pipes/currencyMilion.pipe';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-forecast-price-chart',
    templateUrl: './forecast-price-chart.component.html',
    styleUrls: ['./forecast-price-chart.component.scss'],
    standalone: false
})
export class ForecastPriceChartComponent implements OnInit {
  @Input() priceChartData: any;
  priceChart: any;
  millionPipe: MillionPipe = new MillionPipe;
  @Input() forecastHigh?: number;
  @Input() forecastMedian?: number;
  @Input() forecastLow?: number;
  @Input() current?: number;
  @Input() currency!: string;
  currencyMillion: currencyMilionPipe = new currencyMilionPipe(this.currency);
  currencyPipe: CurrencyPipe = new CurrencyPipe(this.currency);

  diffHigh?: number;
  diffMedian?: number;
  diffLow?: number;

  constructor() { }
  roundToTwo(num: any): number {
    return Math.round(parseFloat(num) * 100) / 100;
  }


  ngOnInit(): void {
    if (this.forecastHigh && this.current)
      this.diffHigh = this.forecastHigh - this.current;
    if (this.forecastLow && this.current)
      this.diffLow = this.forecastLow - this.current;
    if (this.forecastMedian && this.current)
      this.diffMedian = this.forecastMedian - this.current;
    this.generateChart().then((priceChart: any) => {
      // console.log(priceChart)
      // priceChart.register({
      //    afterDatasetsDraw: function (chart: any) {
      //       console.log(chart)
      //      var dataset = chart.data.datasets[0];
      //      var lastPoint = dataset.data[dataset.data.length - 1];

      //      // Define label text and position
      //      var label = "Last Point: " + lastPoint;
      //      var x = chart.scales['x-axis-0'].getPixelForTick(dataset.data.length - 1);
      //      var y = chart.scales['y-axis-0'].getPixelForValue(lastPoint);

      //      // Style the label
      //      chart.ctx.fillStyle = 'red';
      //      chart.ctx.font = '12px Arial';

      //      // Draw the label
      //      chart.ctx.fillText(label, x + 10, y - 10);
      //    }
      //  });
    })
  }

  private generateChart() {
    return new Promise<void>((resolve) => {
      this.priceChart = new Chart("priceChart", {
        type: 'line',
        data: this.priceChartData,
        options: {
          elements: {
            line: { tension: 0 },
            point: {
              radius: 0
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              intersect: false,
              filter: (tooltipItem: TooltipItem<'line'>): boolean => {
                const midPoint = Math.ceil((this.priceChartData.labels?.length ?? 0) / 2) - 1;
                if (tooltipItem.dataIndex === midPoint) {
                  return tooltipItem.datasetIndex === 0;
                }
                return true;
              },
              callbacks: {
                label: (tooltipItem: TooltipItem<'line'>): string => {
                  const value = tooltipItem.raw as number;
                  return `${this.currencyMillion.transform(value, this.currency)}`;
                }
              }
            }
          },
          maintainAspectRatio: true,
          scales: {
            y: {
              stacked: false,
              beginAtZero: false,
              ticks: {
                callback: (value: string | number): string => { return `${this.currencyMillion.transform(value, this.currency)}` }
              },
              grid: {
                // display: false
              }
            },
            x: {
              ticks: {
                callback: (value: string | number, index: number): string | null => {
                  const labelsLength = this.priceChartData.labels?.length ?? 0;
                  if ((labelsLength - 1) === index || ((labelsLength / 2) - 1) === index) {
                    return ''
                  }
                  return null
                }
              }
            }
          }
        }
      });
      resolve(this.priceChart)
    })
  }

}











// import { Component, OnInit } from '@angular/core';
// import { Chart } from 'chart.js';

// @Component({
//   selector: 'app-forecast-price-chart',
//   templateUrl: './forecast-price-chart.component.html',
//   styleUrls: ['./forecast-price-chart.component.scss']
// })
// export class ForecastPriceChartComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//     var myChart = new Chart("priceChart", {
//       type: 'line',
//       data: {
//         labels: ['', 'Last 12 months', 'Next 12 months'],
//         datasets: [
//           {
//             label: 'High',
//             data: [3, 12, 8],
//             borderColor: '#EAC4D5',
//             fill: false,
//           },
//           {
//             label: 'Median',
//             data: [3, 12, 2],
//             borderColor: '#D6EADF',
//             fill: false
//           },
//           {
//             label: 'Low',
//             data: [3, 12, 15],
//             borderColor: '#95B8D1',
//             fill: false
//           }
//         ],

//       },
//       options: {
//         elements: {
//           line: {
//             tension: 0
//           }
//         },
//         legend: {
//           display: false
//         },
//         maintainAspectRatio: true,
//         scales: {
//           yAxes: [{
//             stacked: false,
//             ticks: {
//               beginAtZero: true
//             }
//           }]
//         }
//       }
//     });
//   }

// }
